<template>
  <div>
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row dense>
      <!-- Student Image -->
      <v-col md="2" sm="4" cols="12" class="d-flex justify-center">
        <v-img v-if="child_data.length > 0 && child_data[0].photo_path" :src="awspath + child_data[0].photo_path"
          class="student-image" cover />
      </v-col>

      <v-col md="10" sm="8" cols="12" class="py-0">
        <v-row dense>
          <v-col cols="12" sm="3" md="3" v-if="this.usertype === 'Employee'"></v-col>
          <v-col cols="12" sm="6" md="6" class="d-flex align-center" v-if="this.usertype === 'Employee'">
            <v-autocomplete :items="learner_list" v-model="learner" item-text="name" label="Search Student" dense :loading="fetch_loader"
              item-value="lid" outlined placeholder="Search by PRN No or Name" @change="call2"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex align-center" v-else>
            <v-autocomplete required dense rounded :items="learner_list" v-model="learner" item-text="learner"
              item-value="id" label="Please Select Child" outlined @change="call2" />
          </v-col>

        </v-row>
        <center v-if="this.usertype === 'Employee' && this.learner != ''">
          <strong>Details Shown For Academic Year - {{ current_academicyear }}</strong>
        </center>
        <!-- Student Details Table -->
        <v-row v-if="child_data.length > 0">
          <v-col cols="12" class="pt-0">
            <v-card class="pa-1 elevation-2">
              <div class="table-wrapper">
                <v-simple-table class="table-styled">
                  <template v-slot:default>
                    <tbody>
                      <template v-for="item in child_data">
                        <tr :key="item.id + '-main'" class="row-bordered">
                          <td class="cell-box">
                            <strong>Registration No.</strong><br />{{ item.grno }}
                          </td>
                          <td class="cell-box">
                            <strong>Grade/Division/Roll No</strong><br />{{ item.std_div_rno }}
                          </td>
                          <td class="cell-box">
                            <strong>Class Teacher</strong><br />{{ item.class_teacher }}
                          </td>
                          <td class="cell-box">
                            <strong>Mobile No.</strong><br />{{ item.mobile_no }}
                          </td>
                          <td class="cell-box">
                            <strong>Email</strong><br />{{ item.email }}
                          </td>
                          <td class="cell-box">
                            <strong>Date Of Birth</strong><br />{{ item.dob }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-if="this.learner != ''">
      <v-row v-if="profile_relative_tab.length > 0">
        <v-col cols="12" md="2">
          <v-tabs v-model="tabs" :vertical="$vuetify.breakpoint.mdAndUp" show-arrows grow class="responsive-tabs"
            slider-color="primary" background-color="transparent">

            <v-tab v-if="profile_relative_tab.indexOf('basic_details') !== -1">
              <v-icon class="mr-2">mdi-account</v-icon>
              <span class="tab-text">Basic Details</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('address_details') !== -1">
              <v-icon class="mr-2">mdi-home-map-marker</v-icon>
              <span class="tab-text">Address Details</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('guardian_details') !== -1">
              <v-icon class="mr-2">mdi-account-multiple-outline</v-icon>
              <span class="tab-text">Guardian Details</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('last_school_info') !== -1">
              <v-icon class="mr-2">mdi-school</v-icon>
              <span class="tab-text">Last School Info</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('upload_student_photo') !== -1">
              <v-icon class="mr-2">mdi-camera</v-icon>
              <span class="tab-text">Upload Student Photo</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('upload_documents') !== -1">
              <v-icon class="mr-2">mdi-upload</v-icon>
              <span class="tab-text">Upload Documents</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('transport_info') !== -1">
              <v-icon class="mr-2">mdi-bus</v-icon>
              <span class="tab-text">Transport Info</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('medical_details') !== -1">
              <v-icon class="mr-2">mdi-medical-bag</v-icon>
              <span class="tab-text">Medical Details</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('awards_achievements') !== -1">
              <v-icon class="mr-2">mdi-trophy-variant</v-icon>
              <span class="tab-text">Awards/Achievements</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('student_activity') !== -1">
              <v-icon class="mr-2">mdi-medal</v-icon>
              <span class="tab-text">Student Activity</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('skills_and_interests') !== -1">
              <v-icon class="mr-2">mdi-head-lightbulb</v-icon>
              <span class="tab-text">Skills and Interests</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('ID_card') !== -1">
              <v-icon class="mr-2">mdi-card-account-details</v-icon>
              <span class="tab-text">ID-Card</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('current_subjects') !== -1">
              <v-icon class="mr-2">mdi-bookshelf</v-icon>
              <span class="tab-text">Current Subjects</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('leave_late_marks') !== -1">
              <v-icon class="mr-2">mdi-account-clock</v-icon>
              <span class="tab-text">Leave-Late Marks</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('social_details') !== -1">
              <v-icon class="mr-2">mdi-monitor-cellphone-star</v-icon>
              <span class="tab-text">Social Details</span>
            </v-tab>
            <v-tab v-if="profile_relative_tab.indexOf('payment_history') !== -1">
              <v-icon class="mr-2">mdi-account-cash</v-icon>
              <span class="tab-text">Payment History</span>
            </v-tab>
          </v-tabs>
        </v-col>

        <!-- Tab Content Column -->
        <v-col cols="12" md="10" class="pa-2">
          <v-tabs-items v-model="tabs">

            <v-tab-item v-if="profile_relative_tab.indexOf('basic_details') !== -1">
              <BasicDetailsStudent :key="updateLerner" :learner="learner"
                :profile_relative_tab="profile_relative_tab" />
            </v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('address_details') !== -1">
              <v-card flat>
                <AddressDetailsStudent :key="updateLerner" :learner="learner" />
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('guardian_details') !== -1">
              <v-card flat>
                <GuardianDetailsStudent :learner="learner" :key="updateLerner"
                  :profile_relative_tab="profile_relative_tab" />
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('last_school_info') !== -1">
              <v-card flat>
                <LastSchoolInfoStudent :learner="learner" :key="updateLerner" />
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('upload_student_photo') !== -1">
              <v-card flat>
                <UploadStudentPhotoStudent :learner="learner" :key="updateLerner" />
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('upload_documents') !== -1">
              <v-card flat>
                <UploadDocumentsStudent :learner="learner" :key="updateLerner" />
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('transport_info') !== -1">
              <v-card flat>
                <TransportInfoStudent :learner="learner" :key="updateLerner" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('medical_details') !== -1">
              <v-card flat>
                <MedicalDetailsStudent :learner="learner" :key="updateLerner"
                  :profile_relative_tab="profile_relative_tab" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('awards_achievements') !== -1"><v-card flat>
                <AwardsAchievementsStudent :learner="learner" :key="updateLerner" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('student_activity') !== -1"><v-card flat>
                <ActivityStudent :key="updateLerner" :learner="learner" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('skills_and_interests') !== -1"><v-card flat>
                <SkillsandInterestsStudent :learner="learner" :key="updateLerner"
                  :profile_relative_tab="profile_relative_tab" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('ID_card') !== -1"><v-card flat>
                <DisplayIDCardStudent :learner="learner" :key="updateLerner"
                  :profile_relative_tab="profile_relative_tab" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('current_subjects') !== -1"><v-card flat>
                <CurrentSubjectsStudent :learner="learner" :key="updateLerner" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('leave_late_marks') !== -1"><v-card flat>
                <LeavesLateMarksStudent :learner="learner" :key="updateLerner"
                  :profile_relative_tab="profile_relative_tab" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('social_details') !== -1"><v-card flat>
                <SocialDetailsStudent :learner="learner" :key="updateLerner" />
              </v-card></v-tab-item>
            <v-tab-item v-if="profile_relative_tab.indexOf('payment_history') !== -1"><v-card flat>
                <PaymentHistoryStudent :learner="learner" :key="updateLerner" />
              </v-card></v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>

      <v-row class="justify-center mt-10" v-else>
        <v-card>
          <v-card-title> Please Add Field Configuration..!</v-card-title>

        </v-card>
      </v-row>
    </div>


  </div>
</template>
<script>
import BasicDetailsStudent from "./BasicDetailsStudent.vue";
import AddressDetailsStudent from "./AddressDetailsStudent.vue";
import GuardianDetailsStudent from "./GuardianDetailsStudent.vue";
import LastSchoolInfoStudent from "./LastSchoolInfoStudent.vue";
import UploadStudentPhotoStudent from "./UploadStudentPhotoStudent.vue";
import UploadDocumentsStudent from "./UploadDocumentsStudent.vue";
import TransportInfoStudent from "./TransportInfoStudent.vue";
import MedicalDetailsStudent from "./MedicalDetailsStudent.vue";
import AwardsAchievementsStudent from "./AwardsAchievementsStudent.vue";
import SkillsandInterestsStudent from "./SkillsandInterestsStudent.vue";
import DisplayIDCardStudent from "./DisplayIDCardStudent.vue";
import CurrentSubjectsStudent from "./CurrentSubjectsStudent.vue";
import LeavesLateMarksStudent from "./LeavesLateMarksStudent.vue";
import SocialDetailsStudent from "./SocialDetailsStudent.vue";
import PaymentHistoryStudent from "./PaymentHistoryStudent.vue";
import ActivityStudent from "./ActivityStudent.vue";
import axios from "axios";
export default {
  name: "FillProfile",
  components: {
    BasicDetailsStudent,
    ActivityStudent,
    AddressDetailsStudent,
    GuardianDetailsStudent,
    LastSchoolInfoStudent,
    UploadStudentPhotoStudent,
    UploadDocumentsStudent,
    TransportInfoStudent,
    MedicalDetailsStudent,
    AwardsAchievementsStudent,
    SkillsandInterestsStudent,
    DisplayIDCardStudent,
    CurrentSubjectsStudent,
    LeavesLateMarksStudent,
    SocialDetailsStudent,
    PaymentHistoryStudent,
  },
  data() {
    return {
      learner: "",
      showSnackbar: "",
      awspath: "",
      usertype: "",
      learner_list: [],
      child_data: [],
      snackbar: false,
      updateLerner: 0,
      color: "",
      current_academicyear: "",
      snackbar_msg: "",
      tabs: 0, // In Vuetify 2, tabs are numbered indexes
      profile_relative_tab: [], // ARRAY, not object
      fetch_loader:false
    };
  },
  mounted() {
    this.getDynamicProfileTabs();
    this.usertype = localStorage.getItem("EPS-ut");
    if (this.usertype === 'Employee') {
      this.getAlllearnerForEmployee();
    }
    if (this.usertype === 'Parent') {
      this.learner = localStorage.getItem("learner_for_profile");
      this.getlearner();
    }



    this.awspath = localStorage.getItem("awspath");

  },
  methods: {
    async getAlllearnerForEmployee() {
      this.child_data = [];
      this.fetch_loader = true;
      try {
        const res = await axios.post(
          "/admission/getAllStudents_edit_student");
        if (res.data.msg == "200") {
          this.learner_list = res.data.stud_list;
          this.current_academicyear = res.data.current_academicyear;
          this.fetch_loader = false;
        } else {
          alert("Somthing went wrong!!!");
          this.fetch_loader = false;
        }
      } catch (err) { } finally {
        console.log("bye...");
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },

    async getDynamicProfileTabs() {
      try {
        const res = await axios.post("/parent/getDynamicProfileTabs");
        if (res.data.flag == "YES") {
          this.profile_relative_tab = res.data.profile_relative_tab; // keep as array
        } else {
          this.showSnackbar("red", res.data.msg);
        }
      } catch (err) {
        this.showSnackbar("red", "Something went wrong.");
      }
    },
    async getlearner() {
      this.child_data = [];
      const data = {
        learner: this.learner,
      };
      try {
        const res = await axios.post("/parentDashboard/getchildProfiledata", data);
        if (res.data.flag == "YES") {
          this.learner_list = res.data.learner_list;
          if (this.usertype === "Parent" && this.learner_list.length > 0) {
            // Set the first learner as default if learner is not already set
            if (!this.learner) {
              this.learner = this.learner_list[0].id;
              localStorage.setItem("learner_for_profile", this.learner);
              await this.call2(); // Trigger data fetch for the default learner
            } else {
              this.learner = parseInt(localStorage.getItem("learner_for_profile"));
            }
            this.child_data = res.data.child_data;
          }
        } else {
          this.showSnackbar("red", res.data.snackbar);
        }
      } catch (err) {
        this.showSnackbar("red", "Something went wrong.");
      } finally {
        console.log("bye...");
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    printProfileDetails() {
      this.$router.push({ name: "ViewFillProfile" });
    },
    printProfileWithUndertakingDetails() {
      this.$router.push({ name: "AdmissionFormWithUndertaking" });
    },
    async call2() {

      this.child_data = [];
      const data = {
        learner: this.learner,
      };
      try {
        const res = await axios.post(
          "/parentDashboard/getchildProfiledata",
          data
        );
        if (res.data.flag == "YES") {
          this.updateLerner++
          localStorage.setItem("learner_for_profile", this.learner);
          if (this.usertype === 'Parent') {
            this.child_data = res.data.child_data;
            if (res.data.child_data[0].photo_path) {

            }
          }

          // this.upcomingEvents();
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
      } finally {
        console.log("bye...");
      }
    },
  },
};
</script>

<style scoped>
.student-image {
  border: 1px solid black;
  width: 100%;
  max-width: 100px;
  height: 120px;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  border-radius: 4px;
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
}


.v-col {
  margin-bottom: 12px;
}

.v-tabs {
  background: var(--v-brandLight-base);
  border: 1px solid var(--v-brand-base);
  border-radius: 20px;
}

.v-tab {
  justify-content: flex-start !important;
  text-transform: none !important;
  padding-left: 16px !important;
  min-height: 48px;
  align-items: center;
}

.v-tab--active {
  background: #ffffff !important;
  color: #000 !important;
  font-weight: bold;
  border-radius: 8px;
}

.v-tab .v-icon {
  margin-right: 10px;
}


.tab-text {
  display: inline-block;
  font-size: 14px;
}

/* Mobile adjustment */
@media (max-width: 600px) {
  .tab-text {
    display: none;
  }
}

.table-styled {
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;
}


.row-bordered {
  border: 1px solid #e0e0e0;
}

.responsive-tabs {
  max-width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

.cell-box {
  text-align: center;
  vertical-align: top;
  padding: 8px;
  border: 2px solid var(--v-brand-base);
  background-color: var(--v-brandLight-base);
  font-size: 12px;
}
</style>
